import { createSelector } from 'reselect';

import { IStageDataState } from '../../states/dataState';
import * as stageTypes from '../../../stage/types';

import * as stagesActions from '../../actions/data/stages';
import * as stageActions from '../../actions/data/stage';
import * as _ from 'lodash';
import * as commonTypes from '../../../shared/types';

import { QUESTION_TYPES } from '../../../stage/types/constants';

const initialState = {
  currentStageId: null,
  currentStageName: null,
  selectedPageId: 1,
  pages: null,
  status: null,
  loading: false,
  attachmentEntities: {},
  attachmentDownloading: {},
  mobileInfo: {}
};

export function stageReducer(state: IStageDataState = initialState,
  action: stagesActions.Actions | stageActions.Actions): IStageDataState {
  switch (action.type) {
    case stagesActions.ActionTypes.GET_STAGE_INFO:
    case stageActions.ActionTypes.GET_STAGE:
    case stageActions.ActionTypes.UPDATE_STAGE:
      return Object.assign({}, state, { loading: true });
    case stageActions.ActionTypes.SERVER_ACTION:
    case stageActions.ActionTypes.DOCUMENT_CONFIRMATION:
    case stageActions.ActionTypes.DOWNLOAD_ATTACHMENT:
      var currentAttachmentDownloading: commonTypes.IStatus[] = state.attachmentDownloading[state.selectedPageId];
      var updatedAttachmentDownloading = {
        [state.selectedPageId]: currentAttachmentDownloading.map((attachmentStatus: commonTypes.IStatus) => {
          const questionId = (<stageTypes.IAttachmentDownload>action.payload).questionId;
          if (attachmentStatus.currentId === String(questionId)) {
            return Object.assign({}, attachmentStatus, { loading: true, currentAction: (<stageTypes.IAttachmentDownload>action.payload).action });
          } else {
            return Object.assign({}, attachmentStatus);
          }
        })
      };

      return Object.assign({}, state, { attachmentDownloading: updatedAttachmentDownloading });
    case stagesActions.ActionTypes.GET_STAGE_INFO_SUCCESS:
      const starterResponse: stageTypes.IStarterResponse = <stageTypes.IStarterResponse>action.payload;
      const currentStage: stageTypes.IStage = starterResponse._embedded.stages[0];
      return {
        currentStageId: currentStage.id,
        currentStageName: currentStage.name,
        selectedPageId: state.selectedPageId,
        status: null,
        pages: null,
        loading: false,
        attachmentEntities: {},
        attachmentDownloading: {},
        mobileInfo: {}
      };
    case stagesActions.ActionTypes.GET_STAGE_INFO_FAIL:
    case stageActions.ActionTypes.GET_STAGE_FAIL:
      return Object.assign({}, state, {
        status: {
          type: commonTypes.MessageType.ERROR,
          message: action.payload['message']
        },
        loading: false,
        currentAction: ''
      });
    case stageActions.ActionTypes.SELECT_PAGE:
      // TODO: quite redundant as attachmentEntities was created in GET_STAGE_SUCCESS
      // leave it here for now
      const _selectedPageId = String(action.payload);
      if (_.has(state.attachmentEntities, _selectedPageId)) {
        return Object.assign({}, state, {
          selectedPageId: action.payload
        });
      } else {
        const newPage = {
          [_selectedPageId]: []
        };
        return Object.assign({}, state, {
          selectedPageId: action.payload,
          attachmentEntities: Object.assign({}, state.attachmentEntities, newPage)
        });
      }
    // case stageActions.ActionTypes.UPDATE_STAGE:
    //   return Object.assign({}, state, { currentStageId: action.payload });
    case stageActions.ActionTypes.RESET_STAGE:
      return Object.assign({}, initialState, { selectedPageId: action.payload, status: null });
    case stageActions.ActionTypes.GET_STAGE_SUCCESS:
      let stageData: stageTypes.IStageResponse = (<stageTypes.IStageResponse>action.payload);
      // mobile info
      let _mobileInfo: stageTypes.IMobileStageResponse = {};
      if (_.has(stageData, 'smssecret') && _.has(stageData, 'mobile') && _.has(stageData, 'expire')) {
        _mobileInfo = {
          expire: stageData.expire,
          mobile: stageData.mobile,
          smssecret: stageData.smssecret
        };
      }

      let _processAttachments = (stageData: stageTypes.IStageResponse): Object => {
        let stagePages = stageData.pages;
        switch (stageData.id) {
          case 3:
            let confirmedDocuments = stagePages.reduce(
              (attachmentEntities: {
                [pageId: string]: commonTypes.IStatus[]
              },
                currentPage: stageTypes.IPage
              ) => Object.assign(attachmentEntities, {
                [currentPage.id]: _.filter(currentPage.htmlelements, (element: stageTypes.IHtmlElement) => element.confirmed)
                  .map((e: stageTypes.IHtmlElement, index: number) => {
                    let ret: commonTypes.IStatus = {
                      confirmed: e.confirmed,
                      downloaded: e.confirmed,
                      loading: false,
                      status: null,
                      currentId: String(e.id),
                      currentAction: '',
                      result: e.actions[0].href
                    };
                    return ret;
                  })
              }),
              {}
            );
            //Unconfirmed
            let unconfirmedDocuments = stagePages.reduce(
              (attachmentDownloading: {
                [pageId: string]: commonTypes.IStatus[]
              },
                currentPage: stageTypes.IPage
              ) => {
                let statuses: commonTypes.IStatus[] = [];
                for (let i = 0; i < currentPage.htmlelements.length; i++) {
                  let element = currentPage.htmlelements[i];
                  statuses.push({
                    currentId: String(element.id),
                    status: null,
                    loading: false,
                    downloaded: false,
                    confirmed: false,
                    currentAction: '',
                  });
                }
                return Object.assign(attachmentDownloading, { [currentPage.id]: statuses });
              }, {});

            return {
              pages: stagePages,
              loading: false,
              attachmentEntities: confirmedDocuments,
              attachmentDownloading: unconfirmedDocuments
            };
          case 4:
          case 1:
          case 2:
          case 31:
            // downloaded documents
            var downloadedEntities = stagePages.reduce(
              (attachmentEntities: {
                [pageId: string]: commonTypes.IStatus[]
              },
                currentPage: stageTypes.IPage
              ) => Object.assign(attachmentEntities, {
                [currentPage.id]: _.filter(currentPage.fields, (field: stageTypes.IPageDef) => (_.has(field, 'status') && field.status))
                  .map((field: stageTypes.IPageDef, index: number) => {
                    let ret: commonTypes.IStatus = {
                      confirmed: false,
                      downloaded: true,
                      loading: false,
                      status: null,
                      currentId: String(index),
                      currentAction: ''
                    };
                    return ret;
                  })
              }),
              {}
            );

            // undownloaded docos
            var undownloadedEntities = stagePages.reduce(
              (attachmentDownloading: {
                [pageId: string]: commonTypes.IStatus[]
              },
                currentPage: stageTypes.IPage
              ) => {
                let statuses: commonTypes.IStatus[] = [];
                for (let i = 0; i < currentPage.fields.length; i++) {
                  const field = currentPage.fields[i];
                  if (field.type === QUESTION_TYPES.ATTACHMENTS) {
                    statuses.push({
                      currentId: String(i),
                      currentAction: '',
                      status: null,
                      loading: false,
                      downloaded: false,
                      confirmed: false
                    });
                  }
                }
                return Object.assign(attachmentDownloading, { [currentPage.id]: statuses });
              }, {});

            return {
              pages: stagePages,
              loading: false,
              attachmentEntities: downloadedEntities,
              attachmentDownloading: undownloadedEntities
            };
          case 0:
          case 6:
          case 5:
          case 40:
            // downloaded documents
            var downloadedEntities = stagePages.reduce(
              (attachmentEntities: {
                [pageId: string]: commonTypes.IStatus[]
              },
                currentPage: stageTypes.IPage
              ) => Object.assign(attachmentEntities, {
                [currentPage.id]: []
              }),
              {}
            );
            // undownloaded docos
            var undownloadedEntities = stagePages.reduce(
              (attachmentDownloading: {
                [pageId: string]: commonTypes.IStatus[]
              },
                currentPage: stageTypes.IPage
              ) => {
                let statuses: commonTypes.IStatus[] = [];
                _.forEach(currentPage.elements, (value: stageTypes.IHtmlElement, key: string) => {
                  //if (value.type === QUESTION_TYPES.FILE_BLOCK) {
                  if (_.has(value, 'actions') && value.actions.length) {
                    statuses.push({
                      currentId: String(value.id),
                      currentAction: '',
                      status: null,
                      loading: false,
                      downloaded: false,
                      confirmed: false
                    });
                  }
                });
                return Object.assign(attachmentDownloading, { [currentPage.id]: statuses });
              }, {});
            return {
              pages: stagePages,
              loading: false,
              attachmentEntities: downloadedEntities,
              attachmentDownloading: undownloadedEntities
            };
          default:
            break;
        }

      }

      return Object.assign({}, state, _processAttachments(stageData), { mobileInfo: _mobileInfo });
    // TODO: abstract and refactor for all stages and attachments
    case stageActions.ActionTypes.SERVER_ACTION_FAIL:
    case stageActions.ActionTypes.DOCUMENT_CONFIRMATION_FAIL:
    case stageActions.ActionTypes.DOWNLOAD_ATTACHMENT_FAIL:
      var currentAttachmentDownloading: commonTypes.IStatus[] = state.attachmentDownloading[state.selectedPageId];
      var updatedAttachmentDownloading = {
        [state.selectedPageId]: currentAttachmentDownloading.map((attachmentStatus: commonTypes.IStatus) => {
          const questionId = (<stageTypes.IAttachmentDownload>action.payload['data']).questionId;
          if (attachmentStatus.currentId === String(questionId)) {
            return Object.assign({}, attachmentStatus, { loading: false, currentAction: '' });
          } else {
            return Object.assign({}, attachmentStatus);
          }
        })
      };

      return Object.assign({}, state, {
        status: {
          type: commonTypes.MessageType.ERROR,
          message: 'Failed Action'
        },
        attachmentDownloading: updatedAttachmentDownloading,
        loading: false
      });
    case stageActions.ActionTypes.DOWNLOAD_ATTACHMENT_SUCCESS:
      const currentAttachments: commonTypes.IStatus[] = state.attachmentEntities[state.selectedPageId];
      let newAttachments = [...currentAttachments];

      const genType = (fileName): string => {
        if (!fileName || fileName.lastIndexOf('.') === -1) {
          return 'text/plain';
        }
        const type = fileName.substr(fileName.lastIndexOf('.') + 1);
        switch (type) {
          case 'txt':
            return 'text/plain';
          case 'xml':
          case 'html':
            return 'text/' + type;
          case 'json':
            return 'octet/stream';
          default:
            return 'application/' + type;
        }
      };

      if (!_.find(currentAttachments,
        (att: commonTypes.IStatus) => att.currentId === String((<stageTypes.IAttachmentDownload>action.payload).questionId))) {
        const payload = (<stageTypes.IAttachmentDownload>action.payload);
        newAttachments = [...currentAttachments, {
          currentAction: '',
          downloaded: true,
          confirmed: false,
          loading: false,
          status: null,
          currentId: String((<stageTypes.IAttachmentDownload>action.payload).questionId),
          result: new Blob([payload.result],
            {
              type: genType(payload.name)
            }
          )
        }];
      }

      var currentAttachmentDownloading: commonTypes.IStatus[] = state.attachmentDownloading[state.selectedPageId];
      var updatedAttachmentDownloading = {
        [state.selectedPageId]: currentAttachmentDownloading.map((attachmentStatus: commonTypes.IStatus) => {
          const questionId = (<stageTypes.IAttachmentDownload>action.payload).questionId;
          if (attachmentStatus.currentId === String(questionId)) {
            return Object.assign({}, attachmentStatus, { loading: false, currentAction: '' });
          } else {
            return Object.assign({}, attachmentStatus);
          }
        })
      };
      return Object.assign({}, state, {
        attachmentEntities: { [state.selectedPageId]: newAttachments },
        attachmentDownloading: updatedAttachmentDownloading,
        loading: false
      });
    case stageActions.ActionTypes.SERVER_ACTION_SUCCESS:
    case stageActions.ActionTypes.DOCUMENT_CONFIRMATION_SUCCESS:
      const downloadedDocs: commonTypes.IStatus[] = state.attachmentEntities[state.selectedPageId];
      var updatedDownloadedDocs = downloadedDocs.map((attachmentStatus: commonTypes.IStatus) => {
        const questionId = (<stageTypes.IAttachmentDownload>action.payload).questionId;
        if (attachmentStatus.currentId === String(questionId)) {
          return Object.assign({}, attachmentStatus, { loading: false, currentAction: '', confirmed: true });
        } else {
          return Object.assign({}, attachmentStatus);
        }
      });

      var currentAttachmentDownloading: commonTypes.IStatus[] = state.attachmentDownloading[state.selectedPageId];
      var updatedAttachmentDownloading = {
        [state.selectedPageId]: currentAttachmentDownloading.map((attachmentStatus: commonTypes.IStatus) => {
          const questionId = (<stageTypes.IAttachmentDownload>action.payload).questionId;
          if (attachmentStatus.currentId === String(questionId)) {
            return Object.assign({}, attachmentStatus, { loading: false, currentAction: '' });
          } else {
            return Object.assign({}, attachmentStatus);
          }
        })
      };
      return Object.assign({}, state, {
        attachmentEntities: { [state.selectedPageId]: updatedDownloadedDocs },
        attachmentDownloading: updatedAttachmentDownloading,
        loading: false
      });
    default:
      return state;
  }
};


export const getCurrentStageId = (stageState: IStageDataState): number => stageState.currentStageId;
export const getCurrentStageName = (stageState: IStageDataState): string => stageState.currentStageName;
export const hasStageInfo = (stageState: IStageDataState): boolean => {
  if (stageState && stageState.currentStageId === 0) {
    return true;
  }
  return !!stageState.currentStageId;
};

export const getStageMobileInfo = (stageState: IStageDataState): stageTypes.IMobileStageResponse => stageState.mobileInfo;
export const getStagePages = (stageState: IStageDataState): stageTypes.IPage[] => stageState.pages;
export const getStagePagesLength = (stageState: IStageDataState): number => stageState.pages ? stageState.pages.length : 0;
export const hasStagePages = (stageState: IStageDataState): boolean => !!stageState.pages;
export const getSelectedPageId = (stageState: IStageDataState): number => stageState.selectedPageId;
export const getSelectedPageData = createSelector(getStagePages, getSelectedPageId, (pages: stageTypes.IPage[], pageId: number) => {
  return _.find(pages, (page: stageTypes.IPage) => page.id === pageId);
});

export const getAttachmentEntities = (stageState: IStageDataState) => stageState.attachmentEntities;
export const getReadAttachments = createSelector(getAttachmentEntities, getSelectedPageId, (entities, pageId) => entities[pageId]);

export const getAttachmentDownloadings = (stageState: IStageDataState) => stageState.attachmentDownloading;
export const getAttachmentDownloadingStatuses = createSelector(getAttachmentDownloadings, getSelectedPageId, (attachmentDownloadings, pageId) => attachmentDownloadings[pageId] || []);

export const allAttachmentsDownloaded = createSelector(getReadAttachments, getAttachmentDownloadingStatuses,
  (downloadedAttachments: commonTypes.IStatus[], attachmentStatuses: commonTypes.IStatus[]) => {
    // TODO: for now just compare the length
    // maybe need to compare item of arrays
    return _.filter(downloadedAttachments, (status: commonTypes.IStatus) => status.downloaded).length === attachmentStatuses.length;
  }
);

export const allAttachmentsConfirmed = createSelector(getReadAttachments, getAttachmentDownloadingStatuses,
  (downloadedAttachments: commonTypes.IStatus[], attachmentStatuses: commonTypes.IStatus[]) => {
    return _.filter(downloadedAttachments, (status: commonTypes.IStatus) => status.confirmed).length === attachmentStatuses.length;
  }
);

export const isDataLoading = (stageState: IStageDataState): boolean => stageState.loading;



// WEBPACK FOOTER //
// ./src/app/stateManagement/reducers/data/stage.reducer.ts